import React from 'react'
import Friend from "./Friend/Friend";
import css from './Friends.module.css'
import Loader from "react-loader-spinner";

const Friends = props => {

    return <div className={css.friends__wrapper}>
        <h2 className={css.friends__title}>{props.follows.length} Follows</h2>
        <div className={css.friends}>
            {props.follows.map(item => <Friend uid={item.uid} name={item.name} photoURL={item.photoURL}
                                               backgroundPhotoUrl={item.backgroundPhotoUrl}/>)}
        </div>
    </div>

}

export default Friends